import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { prepareComponentToken, prepareToken } from '.';
import capitalize from '../../_util/capitalize';
import { genSubStyleComponent } from '../../theme/internal';
var genTagStatusStyle = function genTagStatusStyle(token, status, cssVariableType) {
  var capitalizedCssVariableType = capitalize(cssVariableType);
  return _defineProperty({}, "".concat(token.componentCls).concat(token.componentCls, "-").concat(status), _defineProperty({
    color: token["color".concat(cssVariableType)],
    background: token["color".concat(capitalizedCssVariableType, "Bg")],
    borderColor: token["color".concat(capitalizedCssVariableType, "Border")]
  }, "&".concat(token.componentCls, "-borderless"), {
    borderColor: 'transparent'
  }));
};
// ============================== Export ==============================
export default genSubStyleComponent(['Tag', 'status'], function (token) {
  var tagToken = prepareToken(token);
  return [genTagStatusStyle(tagToken, 'success', 'Success'), genTagStatusStyle(tagToken, 'processing', 'Info'), genTagStatusStyle(tagToken, 'error', 'Error'), genTagStatusStyle(tagToken, 'warning', 'Warning')];
}, prepareComponentToken);